import {SagaIterator} from "redux-saga";
import {all, takeLatest} from "redux-saga/effects";
import {
	fetchBETime,
	fetchChecksumsJSON,
	fetchFAQJson,
	fetchHelpPageJsons,
	fetchHelpPagesJson,
	globalError,
	userBackdoorLogin,
	requestCurrentUser,
	userPreregistration,
} from "modules/actions";
import {errorsManagerSaga} from "modules/sagas/errors";
import {
	fetchChecksumsJSONSaga,
	fetchFAQJSONSaga,
	fetchHelpPageJsonsSaga,
	fetchHelpPagesJSONSaga,
} from "./json";

import {userBackdoorLoginSaga, getCurrentUserSaga, userPreregistrationSaga} from "./user";

import {fetchBackEndTimeSaga} from "modules/sagas/time";

/**
 * Root saga that connect sagas with actions.
 */
export const rootSaga = function* (): SagaIterator {
	yield all([
		/**
		 * JSON
		 */
		takeLatest(fetchChecksumsJSON, fetchChecksumsJSONSaga),
		takeLatest(fetchHelpPagesJson, fetchHelpPagesJSONSaga),
		takeLatest(fetchFAQJson, fetchFAQJSONSaga),
		takeLatest(fetchHelpPageJsons, fetchHelpPageJsonsSaga),

		/**
		 * Common
		 */
		takeLatest(globalError, errorsManagerSaga),
		takeLatest(fetchBETime, fetchBackEndTimeSaga),

		/**
		 * Auth
		 */
		takeLatest(userBackdoorLogin, userBackdoorLoginSaga),
		takeLatest(userPreregistration, userPreregistrationSaga),

		/**
		 * User
		 */
		takeLatest(requestCurrentUser, getCurrentUserSaga),

		/**
		 * Game
		 */

		/**
		 * Contact
		 */

		/**
		 * Leagues
		 */
	]);
};

export * from "./errors";
export * from "./json";
export * from "./time";
export * from "./user";
